import {
  MinAmountWrapper,
  Indicator,
  Message,
  MinAmountValue
} from './MinAmount.styles'
import { getRemainigMinAmount, isNumber, isString } from '../../../utils'
import { MinAmountProps } from './MinAmount.types'
import useId from '../../hooks/useId'

const MinAmount = ({
  className = '',
  message,
  total,
  showIndicator = true,
  minAmount,
  color,
  styles,
  show = true,
  'data-testid': testid = 'min-amount',
  ...props
}: MinAmountProps) => {
  const { getTestId } = useId(testid)
  const { value = 0, ...minAmountProps } = isNumber(minAmount)
    ? { value: minAmount, format: '#,###.##' }
    : minAmount
  const { value: messageValue = '', ...messageProps } = isString(message)
    ? { value: message }
    : message
  const [messagePrefix, messageSuffix] = messageValue.split('{{amount}}', 2)
  const percent = getRemainigMinAmount(value, total)
  const showAmount = messageValue.includes('{{amount}}')

  if (show) {
    return (
      <MinAmountWrapper
        className={`MinAmount ${className}`}
        sx={styles}
        data-testid={getTestId()}
        {...props}>
        <Message
          component="div"
          data-testid={getTestId('message')}
          {...messageProps}>
          {`${messagePrefix} `}
          {!!showAmount && (
            <MinAmountValue
              value={value}
              inline
              data-testid={getTestId('value')}
              {...minAmountProps}
            />
          )}{' '}
          {messageSuffix}
        </Message>
        {!!showIndicator && (
          <Indicator
            value={percent}
            color={color}
            data-testid={getTestId('indicator')}
          />
        )}
      </MinAmountWrapper>
    )
  }
  return null
}

export default MinAmount
